import { Injectable } from '@angular/core';
import {ApiService} from "../../../services/external-api/api.service";
import {IApplicationParametersState} from "../state/application-parameters/application-parameters.state";
import {ConfigurationManager} from "../../configuration-manager/configuration-manager";

@Injectable({
  providedIn: 'root'
})
export class InsightsService {

  constructor(private apiService: ApiService,  private configurationManager: ConfigurationManager) { }

  getFillRate(accessToken: string, param: IApplicationParametersState) {
    const requestParameters = {};
    requestParameters['access_token'] = accessToken;
    requestParameters['datasourcepartyid'] = param.selectedDatasourcePartyId;
    requestParameters['supplier'] = param.selectedSupplierCode;
    requestParameters['noma_code'] = param.selectedNomenclatureCode;
    requestParameters['noma_level'] = param.selectedNomenclatureLevel;
    requestParameters['datefrom'] = param.selectedDateFrom;
    requestParameters['dateuntil'] = param.selectedDateTo;
    return this.apiService.get(this.configurationManager.getApiUrl('apiVendorsUrl') + '/fillrate', requestParameters);
  }
  getStockRotation(accessToken: string, param: IApplicationParametersState) {
    const requestParameters = {};
    requestParameters['access_token'] = accessToken;
    requestParameters['datasourcepartyid'] = param.selectedDatasourcePartyId;

    requestParameters['org_code'] = param.selectedOrganisationCode;
    requestParameters['org_level'] = param.selectedOrganisationLevel;
    requestParameters['noma_code'] = param.selectedNomenclatureCode;
    requestParameters['noma_level'] = param.selectedNomenclatureLevel;
    requestParameters['datefrom'] =  param.selectedDateFrom;
    return this.apiService.get(this.configurationManager.getApiUrl('apiVendorsUrl') + '/stockrotation', requestParameters);
  }

  getMarketShare(accessToken: string, param: IApplicationParametersState) {
    const requestParameters = {};
    requestParameters['access_token'] = accessToken;
    requestParameters['datasourcepartyid'] = param.selectedDatasourcePartyId;

    requestParameters['org_code'] = param.selectedOrganisationCode;
    requestParameters['org_level'] = param.selectedOrganisationLevel;
    requestParameters['noma_code'] = param.selectedNomenclatureCode;
    requestParameters['noma_level'] = param.selectedNomenclatureLevel;
    requestParameters['noma_hier_code'] = '1';
    requestParameters['datefrom'] = param.selectedDateFrom;
    return this.apiService.get(this.configurationManager.getApiUrl('apiVendorsUrl') + '/marketshare', requestParameters);
  }
  getKeyIndicators(accessToken: string, param: IApplicationParametersState) {
    const requestParameters = {};
    requestParameters['access_token'] = accessToken;
    requestParameters['datasourcepartyid'] = param.selectedDatasourcePartyId;

//    requestParameters['org_hier_code'] = environment.orgDefaultHierarchy;
    requestParameters['org_code'] = param.selectedOrganisationCode;
    requestParameters['org_level'] = param.selectedOrganisationLevel;

    requestParameters['noma_code'] = param.selectedNomenclatureCode;
    requestParameters['noma_level'] = param.selectedNomenclatureLevel;
    requestParameters['noma_hier_code'] = '1';

    requestParameters['supplier_code'] = param.selectedSupplierCode;

    requestParameters['datefrom'] = param.selectedDateFrom;
    requestParameters['dateuntil'] = param.selectedDateTo;
    requestParameters['datelevel'] = param.selectedDateLevel;
    return this.apiService.get(this.configurationManager.getApiUrl('apiVendorsUrl') + '/keyindicators', requestParameters);
  }

  getProfitability(accessToken: string, param: IApplicationParametersState) {
    const requestParameters = {};
    requestParameters['access_token'] = accessToken;
    requestParameters['datasourcepartyid'] = param.selectedDatasourcePartyId;

//    requestParameters['org_hier_code'] = environment.orgDefaultHierarchy;
    requestParameters['org_code'] = param.selectedOrganisationCode;
    requestParameters['org_level'] = param.selectedOrganisationLevel;

    requestParameters['noma_code'] = param.selectedNomenclatureCode;
    requestParameters['noma_level'] = param.selectedNomenclatureLevel;
//    requestParameters['noma_hier_code'] = environment.nomaDefaultHierarchy;

    requestParameters['supplier_code'] = param.selectedSupplierCode;

    requestParameters['datefrom'] = param.selectedDateFrom;
    requestParameters['dateuntil'] = param.selectedDateTo;
    requestParameters['datelevel'] = param.selectedDateLevel;
    return this.apiService.get(this.configurationManager.getApiUrl('apiVendorsUrl') + '/profitability', requestParameters);
  }

  getPromo(accessToken: string, param: IApplicationParametersState) {
    const requestParameters = {};
    requestParameters['access_token'] = accessToken;
    requestParameters['datasourcepartyid'] = param.selectedDatasourcePartyId;

    // requestParameters['org_hier_code'] = environment.orgDefaultHierarchy;
    requestParameters['org_code'] = param.selectedOrganisationCode;
    requestParameters['org_level'] = param.selectedOrganisationLevel;

    requestParameters['noma_code'] = param.selectedNomenclatureCode;
    requestParameters['noma_level'] = param.selectedNomenclatureLevel;
    // requestParameters['noma_hier_code'] = environment.nomaDefaultHierarchy;

    requestParameters['supplier_code'] = param.selectedSupplierCode;

    requestParameters['datefrom'] = param.selectedDateFrom;
    requestParameters['dateuntil'] = param.selectedDateTo;
    requestParameters['datelevel'] = param.selectedDateLevel;
    return this.apiService.get(this.configurationManager.getApiUrl('apiVendorsUrl') + '/promoanalysis', requestParameters);
  }

  getKeyIndicatorsSuppliers(accessToken: string, param: IApplicationParametersState) {
    const requestParameters = {};
    requestParameters['access_token'] = accessToken;
    requestParameters['datasourcepartyid'] = param.selectedDatasourcePartyId;

    // requestParameters['org_hier_code'] = environment.orgDefaultHierarchy;
    requestParameters['org_code'] = param.selectedOrganisationCode;
    requestParameters['org_level'] = param.selectedOrganisationLevel;

    requestParameters['noma_code'] = param.selectedNomenclatureCode;
    requestParameters['noma_level'] = param.selectedNomenclatureLevel;
    // requestParameters['noma_hier_code'] = environment.nomaDefaultHierarchy;

    requestParameters['supplier_code'] = param.selectedSupplierCode;

    requestParameters['datefrom'] = param.selectedDateFrom;
    requestParameters['dateuntil'] = param.selectedDateTo;
    requestParameters['datelevel'] = param.selectedDateLevel;
    return this.apiService.get(this.configurationManager.getApiUrl('apiVendorsUrl') + '/keyindicatorssupplier', requestParameters);
  }
  getAvgPrice(accessToken: string, param: IApplicationParametersState) {
    const requestParameters = {};
    requestParameters['access_token'] = accessToken;
    requestParameters['datasourcepartyid'] = param.selectedDatasourcePartyId;

    // requestParameters['org_hier_code'] = environment.orgDefaultHierarchy;
    requestParameters['org_code'] = param.selectedOrganisationCode;
    requestParameters['org_level'] = param.selectedOrganisationLevel;

    requestParameters['noma_code'] = param.selectedNomenclatureCode;
    requestParameters['noma_level'] = param.selectedNomenclatureLevel;
    // requestParameters['noma_hier_code'] = environment.nomaDefaultHierarchy;

    requestParameters['datefrom'] = param.selectedDateFrom;
    requestParameters['dateuntil'] = param.selectedDateTo;
    requestParameters['datelevel'] = param.selectedDateLevel;
    return this.apiService.get(this.configurationManager.getApiUrl('apiVendorsUrl') + '/pricevendor', requestParameters);
  }
  getBestItems(accessToken: string, param: IApplicationParametersState) {
    const requestParameters = {};
    requestParameters['access_token'] = accessToken;
    requestParameters['datasourcepartyid'] = param.selectedDatasourcePartyId;

    // requestParameters['org_hier_code'] = environment.orgDefaultHierarchy;
    requestParameters['org_code'] = param.selectedOrganisationCode;
    requestParameters['org_level'] = param.selectedOrganisationLevel;

    requestParameters['noma_code'] = param.selectedNomenclatureCode;
    requestParameters['noma_level'] = param.selectedNomenclatureLevel;
    // requestParameters['noma_hier_code'] = environment.nomaDefaultHierarchy;

    requestParameters['datefrom'] = param.selectedDateFrom;
    requestParameters['dateuntil'] = param.selectedDateTo;
    requestParameters['datelevel'] = param.selectedDateLevel;
    return this.apiService.get(this.configurationManager.getApiUrl('apiVendorsUrl') + '/bestitems', requestParameters);
  }
  getServiceLevel(accessToken: string, param: IApplicationParametersState) {
    const requestParameters = {};
    requestParameters['access_token'] = accessToken;
    requestParameters['datasourcepartyid'] = param.selectedDatasourcePartyId;

    // requestParameters['org_hier_code'] = environment.orgDefaultHierarchy;
    requestParameters['org_code'] = param.selectedOrganisationCode;
    requestParameters['org_level'] = param.selectedOrganisationLevel;

    requestParameters['noma_code'] = param.selectedNomenclatureCode;
    requestParameters['noma_level'] = param.selectedNomenclatureLevel;
    // requestParameters['noma_hier_code'] = environment.nomaDefaultHierarchy;

    requestParameters['datefrom'] = param.selectedDateFrom;
    requestParameters['dateuntil'] = param.selectedDateTo;
    requestParameters['datelevel'] = param.selectedDateLevel;
    return this.apiService.get(this.configurationManager.getApiUrl('apiVendorsUrl') + '/serviceleveldetail', requestParameters);
  }
}
